import React from 'react';
import { MuiBox } from './style';

const ConnectServicePresenter = () => {
  return (
    <MuiBox>
      <div className="terms-content">
        <div className="agreement-content">
          <p className="title">캐파 커넥트 회원 이용약관</p>
          <br />
          <br />

          <p className="content">
            시행일자 : 2022년 3월 18일
            <br /> 공고일자 : 2022년 3월 18일
          </p>

          <br />
          <br />
          <p className="content">
            제 1조 (목적)
            <br />
            <br />본 약관은 주식회사 에이팀벤처스(이하 “회사”라 합니다)가 CAPA
            Connect 웹페이지(connect.capa.ai, 이하 “서비스 페이지”라 합니다) 및
            모바일 어플리케이션(캐파 커넥트, 이하 “앱”이라 합니다)을 통해
            제공하는 캐파 커넥트 서비스 및 관련 제반 서비스(이하 “서비스”라
            합니다)의 이용과 관련하여 회원과 회사의 관계와 권리의무 등을
            규정함을 목적으로 합니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 2조 (정의)
            <br />
            <br />본 약관에서 사용하는 정의는 다음과 같습니다. 서비스: 회사가
            제공하는 모든 서비스 및 관련 제반 서비스를 의미합니다. 회원: 회사와
            이용계약을 체결하여 회원등록을 한 자로서, 계속적으로 서비스를 이용할
            수 있는 개인이나 법인을 의미합니다. 그룹: 회원의 초대를 받은 복수의
            회원으로 구성된 서비스 내 모임으로서, 한 그룹의 회원들은 동시에 그룹
            내 업로드 된 파일에 접근할 수 있습니다. 이 약관에서 사용하는 용어의
            정의는 제1항에서 정하는 것을 제외하고는 관련법령에서 정하는 바에
            의하며, 관련 법령에서 정하지 않는 것은 일반적인 상관례에 의합니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 3조 (약관의 명시와 개정)
            <br />
            <br />
            회사는 본 약관의 내용과 상호, 영업소 소재지, 대표자의 성명,
            사업자등록번호, 연락처 등을 회원이 쉽게 알 수 있도록 서비스
            초기화면에 게시하거나 기타의 방법으로 회원에게 공지합니다. 다만,
            회사는 약관의 내용을 회원이 연결화면을 통하여 볼 수 있도록 할 수
            있습니다. 회사는 「약관의 규제에 관한 법률」, 「전기통신기본법」,
            「전기통신사업법」, 「정보통신망 이용촉진 및 정보보호 등에 관한
            법률」, 「개인정보 보호법」 등 관련 법령을 위배하지 않는 범위에서 본
            약관을 개정할 수 있습니다. 회사는 약관이 변경되는 경우에는 적용일자
            및 변경사유를 명시하여 현행 약관과 함께 서비스 페이지와 앱 공지사항
            또는 팝업에 그 적용일자로부터 최소한 7일 이전부터 적용일 후 상당한
            기간 동안 게시합니다. 다만, 회원의 권리, 의무에 중대한 영향을 주는
            변경의 경우에는 적용일자 30일 전부터 SMS, MMS, 이메일을 통하여
            회원이 인지할 수 있는 방법으로 개별 통지하도록 합니다. 회원은
            개정되는 약관의 전체 또는 일부 내용에 동의하지 않을 수 있습니다.
            다만, 회사가 약관 변경의 공지를 통해 개정된 약관의 적용일자로부터
            7일(회원에게 불리하거나 중대한 사항의 변경인 경우에는 30일) 내에
            회원이 동의하지 않는다는 의사를 표시하지 아니하면 승인한 것으로
            본다는 뜻을 고지하였음에도, 회원이 동의하지 않는다는 의사를 표시하지
            않는 경우 약관의 변경에 동의한 것으로 봅니다. 개정/변경 약관에
            대하여 거부의사를 표시한 회원은 이용계약의 해지 또는 회원 탈퇴를
            선택할 수 있습니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 4조 (약관 외 준칙)
            <br />
            <br />
            회사는 필요한 경우 본 약관의 하위 규정으로 운영 정책을 정할 수
            있으며, 본 약관과 운영 정책의 내용이 상충되는 경우에는 본 약관의
            내용이 우선 적용됩니다. 본 약관에서 규정하지 않은 사항에 관해서는
            「약관의 규제에 관한 법률」, 「전기통신기본법」, 「전기통신사업법」,
            「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「개인정보
            보호법」 등의 관계법령에 따릅니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 5조 (이용계약의 성립)
            <br />
            <br />
            회사와 회원 사이의 서비스 이용계약(이하 “이용계약”이라 합니다)은
            서비스를 이용하고자 하는 자(이하 “가입신청자”라 합니다)가 회원
            가입에 필요한 정보를 기입한 후 본 약관과 개인정보수집 및 이용 등에
            명시적인 동의의 의사표시를 함으로써 이용신청을 하고, 회사가 이에
            대하여 이용 승낙을 함으로써 성립합니다. 제1항의 이용 승낙은 회사가
            본 약관에 대한 동의를 확인하고 회원가입이 완료되었음을 알리는 문구를
            통지함으로써 이루어지며, 이러한 승낙의 통지가 가입신청자에게
            도달하면 이용계약이 성립합니다. 회사는 만 14세 미만 자의 이용신청을
            제한하고 있습니다. 이용신청 단계에서 만 14세 이상에 해당한다는
            안내에 동의표시를 함으로써 회원은 만 14세 이상임을 진술하고
            보증합니다. 회사는 다음 각 호에 해당하는 신청에 대하여는
            가입신청자의 이용신청에 대하여 승낙하지 않거나, 사후에 이용계약을
            해지할 수 있습니다. 가입신청자가 본 약관에 의하여 과거 회원자격을
            상실한 사실이 있는 경우. 다만, 회원자격 상실 후 3년이 경과한 자로서
            회사의 재가입 승낙을 얻은 경우는 예외로 합니다. 중복 이메일을
            사용하는 경우 회원의 요청에 의하여 탈퇴한 때로부터 1개월이 경과하지
            아니한 경우 가입신청자가 기입한 회원정보에 명백한 허위 기재, 누락
            또는 오기가 있는 경우 만 14세 미만 자인 경우 가입신청자의 귀책사유로
            인하여 이용신청에 대한 승낙이 불가능하거나 기타 규정한 제반 사항을
            위반하여 신청한 경우 회사는 서비스 관련 설비의 여유가 없거나, 기술상
            또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다. 회사가
            본 조 제4항 및 제5항에 따라 가입신청자의 이용신청을 승낙하지 않거나
            유보하는 경우 또는 사후에 이용계약을 해지하는 경우, 회사는
            원칙적으로 그 사실을 해당 사유와 함께 가입신청자에게 통지하여야
            합니다. 본 약관은 회원이 본 약관에 동의한 날부터 회원 탈퇴 시까지
            적용하는 것을 원칙으로 합니다. 다만, 본 약관의 일부 조항은 회원 탈퇴
            후에도 유효하게 적용될 수 있습니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 6조 (회원의 계정 및 비밀번호)
            <br />
            <br />
            회사는 회원의 계정정보를 통하여 당해 회원의 서비스 이용가능 여부 등
            제반 이용자 관리 업무를 수행합니다. 회원은 자신의 계정정보를 선량한
            관리자로서의 주의의무를 다하여 관리하여야 하며, 회원은 서비스의
            이용을 위하여 사용하는 비밀번호에 대한 보호 및 관리 책임을
            부담합니다. 회원이 자신의 아이디 및 비밀번호의 유출 또는 제3자
            사용에 대하여 인지하고도 비밀번호를 변경하지 아니한 경우 또는 이와
            같은 사정을 회사에 통지하지 않거나 회사의 조치에 응하지 아니한 경우
            등 회원이 본 조의 의무를 준수하지 않아 발생하는 모든 손실이나 손해
            등 불이익에 대한 책임은 회사의 고의 또는 중과실이 없는 한 회원에게
            있습니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 7조 (회원에 대한 통지)
            <br />
            <br />
            회사는 서비스와 관련하여 회원에게 개별적 통지가 필요한 경우 SMS, MMS
            또는 이메일로 통지할 수 있습니다. 회사는 회원 전체에 대한 통지의
            경우 7일 이상 서비스 페이지 또는 앱 공지사항 페이지에 게시함으로써
            제1항의 통지에 갈음할 수 있습니다. 단, 회원의 권리, 의무에 중대한
            영향을 주는 내용을 통지하는 경우에는 적용일자 30일 전부터 게시하도록
            하고, 회원의 이메일 주소로 개별 통지하도록 합니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 8조 (서비스의 제공 및 변경)
            <br />
            <br />
            회사는 회원의 이용신청을 승낙한 시점부터 회원에게 서비스를 제공하며,
            회원은 회사가 제공하는 서비스를 본 약관, 운영정책 등 회사가 정한
            규칙에 따라 이용할 수 있습니다. 회사는 회원의 회원가입을 승낙한
            때부터 아래의 내용과 같은 서비스를 제공하며, 연중 무휴, 1일 24시간
            제공함을 원칙으로 합니다. 파일의 업로드 및 열람, 수정 서비스 파일
            공유를 위한 그룹 생성 및 관리 서비스 그룹 내 파일 공유 및 주석 달기,
            그룹 회원 간 채팅 서비스 그룹 내 다운로드 권한을 부여받은 회원에
            한하여 파일의 다운로드 및 수정 서비스 기타 회사가 자체 개발하거나
            다른 회사와의 제휴계약 등을 통하여 회원에게 제공하는 일체의 서비스
            회사가 회원에게 제공하는 서비스에 대하여 회사는 제작, 변경, 유지,
            보수에 관한 포괄적인 권한을 가집니다. 회사는 새로운 서비스 내용,
            각종 버그 패치 등 서비스의 운영상 또는 기술상 필요한 경우, 제공하고
            있는 서비스의 전부 또는 일부를 상시적으로 수정, 추가, 폐지 등 변경할
            수 있습니다. 회사는 서비스의 내용이 변경되는 경우 서비스 페이지 및
            앱에 공지하도록 합니다. 다만, 서비스 내용의 변경으로 인하여 회원의
            권리, 의무에 불리하거나 중요한 영향을 미치는 경우에는 해당 내용을 그
            적용일로부터 30일 전에 서비스 페이지 및 앱에 공지하고, 회원의
            이메일로 개별 통지합니다. 위 서비스 내용의 변경으로 본 약관의 변경이
            필요한 경우에는 제3조에서 정한 절차에 따릅니다. 회사는 서비스가
            변경된 원인이 회사의 고의 또는 중대한 과실로 인한 경우를 제외하고는
            서비스의 변경으로 발생하는 문제에 대해서 책임을 부담하지 않습니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 9조 (정보의 제공 및 광고의 게재)
            <br />
            <br />
            회사는 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를
            서비스 페이지 및 앱에 게시할 수 있습니다. 회사는 다양한 정보를
            회원의 명시적인 사전 동의가 있는 경우에는 이메일이나 서비스 페이지
            및 앱 알림 등의 방법으로도 제공할 수 있습니다. 회원은 법령에 따라
            회사에게 부과된 의무이행을 위한 절차안내 등을 제외하고는 언제든지
            이메일 등에 대해서 수신을 거절할 수 있습니다. 회사는 서비스 운영과
            관련하여 서비스 화면, 이메일 등에 광고를 게재할 수 있습니다. 회사는
            명시적인 사전 동의를 한 회원에 대하여는 광고가 포함된 이메일 등을
            발송할 수 있으며, 광고가 포함된 이메일 등을 수신한 회원은 수신을
            거절할 수 있습니다. 회사는 수신거절에 필요한 절차를 회원에게
            제공합니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 10조 (지식재산권 등)
            <br />
            <br />
            서비스 및 서비스 내 회사가 제작한 콘텐츠 등에 대한 저작권 및
            지식재산권 등 일체의 권리는 회사에 귀속됩니다. 서비스 내 회원이
            작성한 도면 파일 등 콘텐츠의 저작권 및 지식재산권은 회원에게
            귀속됩니다. 회원은 서비스 내에서 작성한 도면 파일 등 콘텐츠에 관하여
            제3자의 저작권 기타 지식재산권을 침해하지 아니할 것을 보증합니다.
            회원이 작성한 콘텐츠와 관련하여 회사와 제3자가 분쟁이 발생할 경우
            회원은 자신의 책임과 비용으로 회사를 완전히 면책시켜야 합니다. 만일
            회사와 제3자간 분쟁으로 인하여 회사에게 손해 및/또는 지출 비용이
            발생할 경우 회원은 회사에게 일체의 손해 및/또는 비용을 배상하여야
            합니다. 단, 회사에게 고의 또는 중대한 과실이 있는 부분에 대해서는
            그러하지 아니합니다. 회원은 서비스 회원으로서의 지위 및 이용권한을
            타인에게 양도하거나 판매, 담보제공 등 처분하여서는 아니 됩니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 11조 (이용계약의 해제·해지 등)
            <br />
            <br />
            회원은 회사가 정한 절차에 따라 탈퇴 신청을 함으로써 이용계약을
            해지할 수 있습니다. 회원이 계약을 해지하는 경우 관련 법령 및
            개인정보처리방침에 따라 회사가 회원정보를 보존하는 경우를 제외하고
            회사는 지체없이 회원의 개인정보를 파기합니다. 회원의 요청에 따라
            삭제된 정보는 복구할 수 없습니다. 다음 각 호의 사유에 해당하는 경우
            회사는 회원의 동의 없이 이용계약을 해지하거나 서비스 이용을 중지할
            수 있습니다. 회원 정보를 허위로 기재한 경우 본 약관 및 관련된 별도의
            서비스 준수 사항을 위반한 경우 타인의 지식재산권을 침해한 경우
            회사의 영업을 방해하거나 회사가 제공하는 서비스와 동일한 업무를
            행하는 경우 회사 또는 다른 회원의 보안을 위협하는 행위를 한 경우
            회원의 개인정보를 본 서비스 외의 목적으로 이용한 경우 기타
            관련법령을 위반하거나 부정한 목적으로 본 서비스를 이용한 경우 회사의
            이용제한 조치로 강제 탈퇴 되는 경우 회원의 계정에 보유 중인 파일 등
            일체의 콘텐츠는 사전 통지 후 삭제됩니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 12조 (회사의 의무)
            <br />
            <br />
            회사는 본 약관 및 관련법령에서 금지하는 행위 및 미풍양속에 반하는
            행위를 하지 않으며, 본 약관에서 정하는 바에 따라 지속적이고 안정적인
            서비스의 제공을 위하여 최선을 다하여 노력합니다. 회사는 회원으로부터
            제기되는 의견이나 불만이 정당하다고 객관적으로 인정될 경우에는
            합리적인 기간 내에 신속하게 처리하여야 합니다. 다만, 처리에 장기간이
            소요되는 경우 회원에게 게시판 또는 이메일 등을 통하여 지체 사유를
            안내하고 처리과정 및 처리결과를 전달합니다. 회사는 천재지변 등
            불가항력이나 시스템 장애로 인하여 서비스가 중단될 경우 빠른 시일
            내에 정상적인 서비스를 제공할 수 있도록 노력합니다. 회사는 회원이
            안전하게 서비스를 이용할 수 있도록 개인정보(신용정보 포함)를 포함한
            일체의 개인정보 보호를 위한 보안시스템을 갖추어야 하며
            개인정보처리방침을 공시하고 준수합니다. 회사는 회원이 사전에
            명시적으로 동의하지 않은 영리목적의 광고성 이메일, 알림 등을
            발송하지 않습니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 13조 (회원의 의무)
            <br />
            <br />
            회원은 회원가입 신청 또는 회원정보 변경 시 회사에 제공되는 모든
            사항을 사실대로 작성하여야 하며, 허위 또는 타인의 정보를 등록할 경우
            회원의 권리를 주장할 수 없습니다. 회원 서비스 이용과 관련하여 다음
            각 호의 행위를 하여서는 안 됩니다. 회원가입 신청 또는 정보 변경 시
            허위 정보를 입력하거나 정보를 누락하는 행위 회사의 업무를 방해하는
            행위 회사 또는 타인의 명예를 훼손하거나 모욕하는 행위 회사 또는
            타인의 지식재산권을 침해하는 행위 타인으로 가장하거나 타인과의
            관계를 허위로 명시하는 행위, 다른 회원의 계정 및 비밀번호를 도용,
            부정하게 사용하는 행위 서비스를 회사의 동의 없이 상업적 목적으로
            이용하는 행위 회사의 직원이나 운영자를 가장, 사칭하거나 또는 타인의
            명의를 도용하여 문서를 등록하거나 메일을 발송하는 행위 회사의 동의
            없이 광고, 홍보, 청약에 관한 자료 또는 스팸, 피싱 등의 메시지를
            전송하는 행위 회사가 제공하는 서비스 이용방법에 의하지 아니하고
            비정상적인 방법으로 서비스를 이용하거나 회사의 정보처리시스템에
            접근하는 행위 매크로 프로그램 등을 사용하여 서비스를 부정한 방법으로
            이용하는 행위 바이러스, 스파이웨어, 애드웨어 등 회사나 다른 회원의
            소프트웨어를 손상시킬 수 있는 컴퓨터 코드, 파일, 소프트웨어 등을
            전송, 게시하는 행위 기타 회사의 약관을 위반하는 행위 기타 관련
            법령을 위반하거나 미풍양속을 해하는 행위 회원은 개인정보가 타인에게
            노출되지 않도록 철저하게 관리하여야 하며, 타인이 회원의 계정을
            사용하고 있음을 인지한 경우에는 즉시 회사에 통보하고 적절한 조치를
            취해야 하며 회사의 안내가 있는 경우에는 그에 따라야 합니다. 회사는
            본 조를 위반하여 회원에게 발생한 불이익에 대하여 회사의 고의 또는
            중대한 과실이 없는 한 어떠한 책임도 지지 않습니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 14조 (개인정보의 보호 및 관리)
            <br />
            <br />
            {`회사는 「개인정보 보호법」 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 관해서는 관련 법령 및 회사의 개인정보처리방침을 따릅니다. 
    회원은 가입 신청 시 기재한 정보가 변경된 경우 지체없이 해당 정보를 수정하여야 하며, 회사는 회원이 이를 수정하지 않아 발생한 불이익에 대하여 책임을 지지 않습니다. 회원은 서비스 페이지 및 앱 내 [마이페이지 > 계정 정보 > 회원정보 수정]에서 언제든지 회원 정보를 열람하고 수정할 수 있습니다. 
    회사는 회원의 개인정보를 본인의 동의 없이 제3자에게 제공, 분실 또는 유출하여서는 아니됩니다. 단, 회원의 동의를 얻은 경우, 기타 법률에 특별한 규정이 있는 경우에는 예외로 합니다. 
    회사는 회원의 귀책사유로 인하여 노출된 회원의 계정정보를 포함한 모든 정보에 대하여 책임을 지지 않습니다.
    회원은 본 서비스 이용 과정에서 얻게 되는 타인의 개인정보를 상업적 목적 또는 개인적 목적으로 사용하여서는 아니 됩니다.`}
          </p>
          <br />
          <br />
          <p className="content">
            제 15조 (손해배상)
            <br />
            <br />
            회사가 그에 책임 있는 사유로 본 약관 또는 관련법령을 위반하여
            회원에게 손해를 입힌 경우 그 손해를 배상합니다. 회원은 고의 또는
            과실로 본 약관 또는 관련법령을 위반하여 회사 또는 제3자에게 손해를
            입힌 경우 그 손해를 배상하여야 하며, 이로 인하여 회사와 제3자 간에
            분쟁이 발생한 경우 자신의 책임과 비용으로 회사를 면책하여야 합니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 16조 (면책)
            <br />
            <br />
            회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중지 및 기타 이에
            준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 회사의
            고의 또는 중과실이 없는 한 서비스 제공에 대하여 책임 지지 않습니다.
            회사는 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로
            발생한 손해에 대한 회사의 고의 또는 중과실이 없는 한 책임이
            면제됩니다. 회사는 회사가 네트워크를 통한 외부의 불법행위를
            차단하고자 관련 법령에 따라 요구되는 보호조치를 이행하였음에도
            불구하고, 분산서비스거부(DDos) 등 네트워크의 안정성을 해치는 행위
            또는 악성프로그램 등에 의하여 발생하는 예기치 못한 회원의 손해에
            대하여 회사의 고의 또는 중과실이 없는 한 책임지지 않습니다. 회사는
            회원의 귀책사유로 인하여 발생한 손해에 대하여는 회사의 고의 또는
            중대한 과실이 없는 한 책임지지 않습니다. 회사가 제공하는 정보와
            자료는 개인적 목적 또는 거래의 목적으로 이용될 수 없습니다. 따라서
            회원이 본 서비스를 통하여 얻는 정보를 이용하여 본 서비스의 목적을
            벗어나 사용함으로써 발생하는 손해 또는 기대이익의 상실에 대하여
            회사는 고의 또는 중대한 과실이 없는 한 책임지지 않습니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 17조 (권리의 양도금지)
            <br />
            <br />
            회원은 회사의 서면 동의 없이 이 약관상의 권리와 의무를 제3자에게
            양도, 증여하거나 이를 담보로 제공할 수 없습니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 18조 (약관의 해석)
            <br />
            <br />본 약관의 해석에 관하여 다툼이 있는 경우 대한민국 법률이
            적용되고 이에 따라 해석됩니다.
          </p>
          <br />
          <br />
          <p className="content">
            제 19조 (분쟁의 해결) <br />
            <br />
            회원과 회사 사이에 발생한 분쟁에 대해 소송이 제기되는 경우
            대한민국법을 준거법으로 하며, 민사소송법 상의 관할법원에 제소합니다.
          </p>
        </div>
      </div>
    </MuiBox>
  );
};

export default ConnectServicePresenter;
